import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { appContext } from '../../util/decorators';
import LiveStreamListing from './LiveStreamListing.jsx';

@appContext
export default class ViasportLiveFeed extends React.PureComponent {

  getUrl(item, country) {
    const articlePageRoute = this.props.articlePageRoute;
    const sport = _.get(item.tags, `sports[0].${country}.slug`);
    return articlePageRoute.url.replace(':sports', sport).replace(':slug', item.slug);
  }

  render() {
    const country = this.props.country || 'se';
    const logo = require(`../../../assets/viasport-logo-${country}.png`);
    const liveStreams = _.chain(this.props.liveStreams)
      .filter(item => item.videos && item.videos.length > 0 && this.context.app.serverTime().isBefore(item.videos[0].data.endPlaybackAt))
      .sortBy('videos[0].data.beginPlaybackFrom')
      .map(item => {
        return {
          title: item.newsFeedTitle || item.title,
          picture: item.videos[0].data.posterUrl,
          url: this.getUrl(item, country),
          startTime: item.videos[0].data.beginPlaybackFrom ? moment(item.videos[0].data.beginPlaybackFrom).locale(this.props.language) : null,
          endTime: item.videos[0].data.endPlaybackAt ? moment(item.videos[0].data.endPlaybackAt) : null,
          league: _.get(item.tags, `competitions[0].${country}.name`),
        };
      })
      .value();

    return (
      <div>
        {
          liveStreams.length > 0 &&
            <div className="viasport-live-feed">
              <header>
                <img src={logo} alt="Viasport" />
              </header>

              <LiveStreamListing liveStreams={liveStreams} />
            </div>
        }
      </div>
    );
  }
}

ViasportLiveFeed.propTypes = {
  liveStreams: React.PropTypes.array,
  articlePageRoute: React.PropTypes.object,
  language: React.PropTypes.string,
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Sidebar/ViasportLiveFeed.jsx